import {
    GET_CAREER_INFO,
    GET_CAREER_INFO_SUCCESS,
    GET_CAREER_INFO_FAILURE,
    EDIT_CAREER_INFO,
    EDIT_CAREER_INFO_SUCCESS,
    EDIT_CAREER_INFO_FAILURE,
    GET_CAREER_PAGE,
    GET_CAREER_PAGE_SUCCESS,GET_CAREER_PAGE_FAILURE,EDIT_CAREER_PAGE,EDIT_CAREER_PAGE_SUCCESS,EDIT_CAREER_PAGE_FAILURE,GET_CAREER_DEFAULT,GET_CAREER_DEFAULT_SUCCESS,GET_CAREER_DEFAULT_FAILURE


  
  } from "./actionTypes"
  
  export const getCareerInfo = (id) => {
    return {
      type: GET_CAREER_INFO,
      payload: id,
    }
  }
  
  export const getCareerInfoSuccess = careerInfo => {
    return {
      type: GET_CAREER_INFO_SUCCESS,
      payload: careerInfo,
    }
  }
  
  export const getCareerInfoFailure = message => {
    return {
      type: GET_CAREER_INFO_FAILURE,
      payload: message,
    }
  }

  export const getCareerPage = () => {
    return {
      type: GET_CAREER_PAGE,
     
    }
  }
  
  export const getCareerPageSuccess = careerInfo => {
   
    return {
      type: GET_CAREER_PAGE_SUCCESS,
      payload: careerInfo,
    }
  }
  
  export const getCareerPageFailure = message => {
    return {
      type: GET_CAREER_PAGE_FAILURE,
      payload: message,
    }
  }

  export const getCareerPageDefault = () => {
    return {
      type:GET_CAREER_DEFAULT,
     
    }
  }
  
  export const getCareerPageDefaultSuccess = careerInfo => {
   
    return {
      type: GET_CAREER_DEFAULT_SUCCESS,
      payload: careerInfo,
    }
  }
  
  export const getCareerPageDefaultFailure = message => {
    return {
      type:GET_CAREER_DEFAULT_FAILURE,
      payload: message,
    }
  }

  export const editCareerInfo=(obj,id)=>{
      return{
          type:EDIT_CAREER_INFO,
          payload:{obj,id}
      }
  }

  export const editCareerInfoSuccess=(message)=>{
      return{
          type:EDIT_CAREER_INFO_SUCCESS,
          payload:message
      }
  }

  export const editCareerInfoFailure=(error)=>{
      return{
          type:EDIT_CAREER_INFO_FAILURE,
          payload:error
      }
  }
  
  export const editCareerPage=(obj)=>{
    return{
        type:EDIT_CAREER_PAGE,
        payload:obj
    }
}

export const editCareerPageSuccess=(message)=>{
    return{
        type:EDIT_CAREER_PAGE_SUCCESS,
        payload:message
    }
}

export const editCareerPageFailure=(error)=>{
    return{
        type:EDIT_CAREER_PAGE_FAILURE,
        payload:error
    }
}
